/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Incidents API
 * AV Services Incidents management API
 * OpenAPI spec version: 1.0
 */

export interface IncidentCountBySeverity {
  /** Number of new incidents of major severity */
  major: number;
  /** Number of incidents of minor severity */
  minor: number;
  /** Number of incidents of critical severity */
  critical: number;
}
